import UploadPBXCsvModal from './UploadPBXCsvModal';
import { PbxCsvUploadTypes } from 'models/enums';

const { PBX_LINES } = PbxCsvUploadTypes;

type UploadPBXLinesModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

function UploadPBXLinesModal({ isOpen, closeModal }: UploadPBXLinesModalProps) {
  return (
    <UploadPBXCsvModal
      isOpen={isOpen}
      closeModal={closeModal}
      uploadType={PBX_LINES}
      header="Upload PBX lines"
      title="Upload PBX lines"
      description="Upload PBX lines from a .csv file"
      dataTestId="upload-pbx-lines-button"
    />
  );
}

export default UploadPBXLinesModal;
